import { render, staticRenderFns } from "./AilmentFilter.vue?vue&type=template&id=fda62f72"
import script from "./AilmentFilter.vue?vue&type=script&lang=js"
export * from "./AilmentFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports